import styled from "styled-components";

export const TabeleRowContent = styled.div`  
  display: grid;
  width: 595px;
  grid-template-columns: 123px 87px 132px 107px 147px;
  margin-bottom: 18px;

  p{
    padding-left: 14px;
    font-size: 12px;
  }

  button{
    width: 100px;
    height: 22px;

    p{
      padding: 0; 
    }
  }
`;

export const InfoImg = styled.img`
  vertical-align: middle;
  width: 12.8px;
  height: 12.8px;  
  cursor: pointer;
  margin-right: 5px;
  margin-bottom: 2px;
`;